import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import { setupGlobalErrorHandlers } from './lib/errorLogger.js'
import { AuthProvider, AuthContext } from './contexts/AuthContext'
import * as authService from './services/auth.service'
import { accountApi } from './services/api.client'
import './index.css'

// Initialize global error handlers for debugging mobile crashes
setupGlobalErrorHandlers()

// Expose auth service and API client to window for console testing (development only)
if (import.meta.env.DEV) {
  window.authTest = authService;
  window.apiTest = accountApi;
}

// Wrapper component to expose auth context methods to window
function AppWrapper() {
  const authContextRef = React.useRef();

  return (
    <AuthProvider>
      <AuthContext.Consumer>
        {(authContext) => {
          // Expose auth context methods to window for testing (development only)
          if (import.meta.env.DEV) {
            authContextRef.current = authContext;
            window.authContext = {
              login: authContext.login,
              logout: authContext.logout,
              signup: authContext.signup,
              checkAuth: authContext.checkAuth,
              getUser: () => authContext.user,
              isLoading: () => authContext.loading,
              isAuthenticated: () => authContext.isAuthenticated,
            };
          }

          return (
            <HelmetProvider>
              <ErrorBoundary>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
              </ErrorBoundary>
            </HelmetProvider>
          );
        }}
      </AuthContext.Consumer>
    </AuthProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <AppWrapper />
    </React.StrictMode>,
)
